import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { convertQueryStringToMap } from "@smallstack/utils";
import { BasePathService } from "./base-path.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common";
import * as i3 from "./base-path.service";
export class RouterUtilService {
    constructor(router, activatedRoute, location, basePathService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.location = location;
        this.basePathService = basePathService;
    }
    async addSearchParameter(key, value) {
        await this.router.navigate([], { queryParams: { [key]: value }, queryParamsHandling: "merge" });
    }
    async removeSearchParameter(key) {
        await this.router.navigate([], { queryParams: { [key]: null }, queryParamsHandling: "merge" });
    }
    async addMultipleQueryParams(paramKeyArray) {
        const params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        paramKeyArray.forEach((item) => {
            params[item.key] = item.value;
        });
        const url = this.router.createUrlTree([], { relativeTo: this.activatedRoute, queryParams: params }).toString();
        await this.router.navigateByUrl(url);
    }
    initializeListRouting(store) {
        const params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        const pageSize = params["pageSize"];
        const pageIndex = params["pageIndex"];
        if (!pageSize || !pageIndex || store?.value?.length < pageIndex || pageIndex < 0) {
            params["pageSize"] = "10";
            params["pageIndex"] = "0";
            const url = this.router.createUrlTree([], { relativeTo: this.activatedRoute, queryParams: params }).toString();
            this.location.go(url);
        }
    }
    /** Either navigates to another website when url starts with http or navigates internally with taking query params into account (which angular router doesn't) */
    async navigateFullUrl(url, addBasePath = true) {
        setTimeout(async () => {
            if (url.startsWith("http"))
                await this.router.navigateByUrl(url);
            else {
                const extractedUrl = url.split("?");
                let domainWithPath = extractedUrl[0];
                if (addBasePath)
                    domainWithPath = this.basePathService.addBasePath(domainWithPath);
                await this.router.navigate([domainWithPath], {
                    queryParams: convertQueryStringToMap(extractedUrl[1]),
                    relativeTo: null,
                    queryParamsHandling: "merge"
                });
            }
        });
    }
}
RouterUtilService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: RouterUtilService, deps: [{ token: i1.Router }, { token: i1.ActivatedRoute }, { token: i2.Location }, { token: i3.BasePathService }], target: i0.ɵɵFactoryTarget.Injectable });
RouterUtilService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: RouterUtilService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: RouterUtilService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i1.ActivatedRoute }, { type: i2.Location }, { type: i3.BasePathService }]; } });
